import React, { useMemo } from 'react'

import { SideNavItems } from '../../../assets/SideNavContent'
import SideNavSection from './SideNavSection'

import { Container } from './style'

const parseJwt = (token) => {
    try {
        if (!token) return null
        const raw = JSON.parse(token)
        const base64Url = raw.split('.')[1]
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
        return JSON.parse(window.atob(base64))
    } catch (err) {
        return null
    }
}

const tokenHasSuperAdmin = () => {
    const tokenData = parseJwt(localStorage.getItem('access_token'))
    if (!tokenData) return false

    const candidates = []
    if (Array.isArray(tokenData.roles)) candidates.push(...tokenData.roles)
    if (Array.isArray(tokenData.authorities)) candidates.push(...tokenData.authorities)
    if (typeof tokenData.role === 'string') candidates.push(tokenData.role)
    if (typeof tokenData.roles === 'string') candidates.push(tokenData.roles)

    return candidates.some((role) => String(role).includes('SUPER_ADMIN'))
}

const SideNav = () => {
    // This admin tool already boots via SUPER_ADMIN user lookup; also hide
    // marked modules when the JWT clearly lacks SUPER_ADMIN.
    const modules = useMemo(() => {
        const isSuperAdmin = tokenHasSuperAdmin()
        return SideNavItems.modules.filter((module) => {
            if (!module.requiresSuperAdmin) return true
            // If JWT has no role claims, keep visible (backend still enforces 403).
            const tokenData = parseJwt(localStorage.getItem('access_token'))
            if (!tokenData) return false
            const hasRoleClaim = tokenData.roles != null || tokenData.authorities != null || tokenData.role != null
            if (!hasRoleClaim) return true
            return isSuperAdmin
        })
    }, [])

    return (
        <Container>
            {modules.map((module) => (
                <SideNavSection key={module.name} section={module} />
            ))}
        </Container>
    )
}

export default SideNav
